<template>
  <div id="CheckCourseware" v-loading="loading" class="mainDiv">
    <div v-if="!this.courseWareId">{{ courseName }}</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="资源库信息" name="first">
        <CoursewareNew-add
          v-if="firstDialog"
          ref="CoursewareAdd"
          :courseWareId="courseWareId"
          :isCurrentComponent="true"
          @jumpToCoursewareManager="jumpToCoursewareManager"
        ></CoursewareNew-add>
      </el-tab-pane>
      <el-tab-pane label="知识清单" name="second">
        <Knowledge-list
          v-if="secondDialog"
          ref="CoursewareAdd"
          :courseName="courseName"
          :courseWareId="courseWareId"
          :userType="userType"
        ></Knowledge-list>
      </el-tab-pane>
      <el-tab-pane label="课件列表" name="third">
        <Courseware-manager
          v-if="thirdDialog"
          ref="CoursewareManager"
          :courseWareId="courseWareId"
          @updateVerifyList="updateVerifyList"
        ></Courseware-manager>
      </el-tab-pane>
      <el-tab-pane label="课件审核" name="fourth" v-if="userType !== '3'">
        <Verify-list
          v-if="thourDialog"
          ref="VerifyList"
          :courseWareId="courseWareId"
          @updateCoursewareManager="updateCoursewareManager"
        ></Verify-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import CoursewareNewAdd from './CoursewareNew-add'
import KnowledgeList from './KnowledgeList'
import CoursewareManager from './CoursewareManager'
import VerifyList from './VerifyList'
import * as api from '@/api/courseware/checkCourseware'
export default {
  name: 'CheckCourseware',
  components: {
    CoursewareNewAdd,
    CoursewareManager,
    KnowledgeList,
    VerifyList,
  },
  props: ['courseWareId', 'courseForName'],
  data() {
    return {
      id: this.courseWareId || this.$route.query.id,
      userType: '',
      loading: false,
      courseName: this.courseForName || '',
      activeName: 'third',
      firstDialog: true,
      secondDialog: true,
      thirdDialog: true,
      thourDialog: true,
    }
  },
  methods: {
    //通过uid获取用户
    getUserByUid() {
      const uid = this.getUId
      api.getUserByUid(uid).then(({ data }) => {
        if (data.code === 100000) {
          this.userType = data.data.type
        }
      })
    },
    //获取课件库名称
    viewCourseWare() {
      api.viewCourseWare(this.id).then(({ data }) => {
        this.courseName = data.data.wareName
      })
    },
    handleClick() {
      // this.$router.push({
      //   name: 'CheckCourseware', //tab所在的页面
      //   query: {
      //     type: this.activeName,
      //     id: this.$route.query.id,
      //   },
      // })
    },

    updateType() {
      let type = this.$route.query.type
      // 判断type的值，更改activeName的值
      if (type === 'first' || type == undefined) {
        this.activeName = 'first'
      } else if (type === 'second') {
        this.activeName = 'second'
        // eslint-disable-next-line keyword-spacing
      } else if (type === 'third') {
        this.activeName = 'third'
      } else if (type === 'fourth') {
        this.activeName = 'fourth'
      }
    },
    // 获取数据
    getList() {
      //      this.loading = true
      //       console.log(this.$route.query.id);
    },
    jumpToCoursewareManager() {
      this.activeName = 'third'
    },
    updateCoursewareManager() {
      this.$refs.CoursewareManager.getList()
    },
    updateVerifyList() {
      this.$refs.VerifyList.getList()
    },
  },
  mounted: function () {
    this.updateType()
  },
  created() {
    this.getUserByUid()
    this.getList()
    if (!this.courseWareId) {
      this.viewCourseWare()
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 14px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
